import { useEffect } from "react";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";
import useAssinar from "../../../SPF/hooks/useAssinar";
import useBuscaSafePayload from "../../../SPF/hooks/useBuscaSafePayload";
import useSetGuard from "../../../../hooks/useSetGuard";
import ReplaceChar from "../../../../components/Formatters/ReplaceChar";

const useAssinarAtividade = ({ dadosOs, atividade, formik }) => {
  const {
    request: assinarRequest,
    data: assinarData,
    errors: assinarErrors,
    isLoading: assinarIsLoading,
  } = useApiClient();

  const setGuardClient = useSetGuard();

  const { errorSafePayload, buscaSafePayload, safePayloadAgrupador } = useBuscaSafePayload();

  const { assinaturaHandler, resetarEnvio } = useAssinar({ setGuardClient });

  const assinarAtividade = () => {
    const parametros = {
      sequencialComunicado: dadosOs.sequencialComunicado,
      sequencialAcaoFiscal: dadosOs.acaoFiscal,
      sequencialAtividade: atividade.sequencialAtividade,
      textoComunicado: ReplaceChar(formik.values.textoImpedimento),
      textoTitulo: "INFORMAÇÃO",
      textoDadosContribuinte: dadosOs.sequencial + dadosOs.inscricaoEstadual + dadosOs.cnpjCpf + dadosOs.razaoSocial,
      cabecalho: atividade?.nomeAtividade,
      anexos: formik.values.anexos,
      impedimentos: formik.values.impedimentos,
      listaExecutoresOs: formik.values.listaExecutoresOs,
      nomeAtividade: atividade.nomeAtividade,
      sequencialOrdemServico: dadosOs.sequencial,
      cpfRepresentante: formik.values.cpfRepresentante,
      nomeRepresentante: formik.values.nomeRepresentante,
      cargoRepresentante: formik.values.cargoRepresentante,
      dataComunicado: formik.values.dataComunicado,
      nuPaginaEdital: formik.values.nuPaginaEdital,
      codigoRastreio: formik.values.codigoRastreio,
      livrosFiscais: formik.values.livrosFiscais,
      listaLivrosDescricao: dadosOs.listaLivrosDescricao,
      txDescricao: ReplaceChar(formik.values.txDescricao),
      fgMonitoramento: dadosOs.fgMonitoramento,
      sequencialTipoAcaoFiscalNovo: formik.values.sequencialTipoAcaoFiscalNovo,
      listaProcedimentos: formik.values.procedimentos,
      fgAnexoBo: formik.values.fgAnexoBo,
      fgAnexoJornal: formik.values.fgAnexoJornal,
      txParametrizacao: formik.values.txParametrizacao,
      txJustificativa: ReplaceChar(formik.values.txJustificativa),
      vlIcmsDevido: formik.values.vlIcmsDevido,
      vlIcmsRecolhido: formik.values.vlIcmsRecolhido,
      vlIcmsParcelado: formik.values.vlIcmsParcelado,
      vlIcmsEstornado: formik.values.vlIcmsEstornado,
      cdProcesso: formik.values.cdProcesso,
      dadosOcorrencia: {
        sequencialAcaoFiscal: dadosOs.acaoFiscal,
        sequencialOrdemServico: dadosOs.sequencial,
        inscricaoEstadual: dadosOs.inscricaoEstadual,
        numCnpj: dadosOs.cnpjCpf,
        razaoSocial: dadosOs.razaoSocial,
        enderecoContribuinte: dadosOs.enderecoContribuinte,
        dtInicioFiscalizacao: dadosOs.dataInicialFiscalizacao,
        dtFimFiscalizacao: dadosOs.dataFinalFiscalizacao,
        listaOcorrencias: dadosOs.ocorrencias,
      },
      siglaAtividade: atividade.siglaAtividade,
      txPreliminares: ReplaceChar(formik.values.txPreliminares),
      txProcedimentos: ReplaceChar(formik.values.txProcedimentos),
      txConstatacoes: ReplaceChar(formik.values.txConstatacoes),
      txOcorrencias: ReplaceChar(formik.values.txOcorrencias),
      txResultado: ReplaceChar(formik.values.txResultado),
    };

    assinarRequest(apiRoutes.fiscalizacao.ordemservico.assinarAtividade, parametros);
  };

  useEffect(() => {
    if (assinarIsLoading) return;

    if (assinarData?.result?.value?.length) {
      buscaSafePayload(assinarData?.result?.value);
    }

    if (assinarErrors) {
      toast.error(assinarErrors.message);
    }
  }, [assinarData, assinarErrors, assinarIsLoading, buscaSafePayload]);

  // safePayloadAgrupador para abrir assinador
  useEffect(() => {
    if (safePayloadAgrupador) {
      resetarEnvio();
      assinaturaHandler(safePayloadAgrupador);
    }

    if (errorSafePayload) {
      toast.error(errorSafePayload.message);
    }
  }, [errorSafePayload, safePayloadAgrupador, assinaturaHandler, resetarEnvio]);

  return { assinarIsLoading, assinarAtividade, assinarErrors };
};

export default useAssinarAtividade;
